module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/credit-cards/maestro-1e8730f0ea727ac468a3870361fb9084.jpg";